import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';
import { FspItemType } from '../Enums/FspItemType.enum';

export class FspItem<T extends EMode = EMode.entity> {
  /** Alias: itemId */
  itemId?: string;
  /** Alias: key */
  key?: string;
  /** Alias: itemType */
  itemType?: FspItemType;

  __typename?: string;
}

const fields: FieldDefinitions<FspItem> = {
  itemId: {
    alias: 'itemId',
  },
  key: {
    alias: 'key',
  },
  itemType: {
    alias: 'itemType',
  },
  __typename: {
    alias: '__typename',
  },
};

export const fspItemEntityDefinition: EntitiyDefinition<FspItem> = {
  local: {},
  remote: {
    queryName: 'listFileServiceProviderConfigRootItems',
    fragmentName: 'FspItem',
    withPaginationWrapper: false,
    params: [
      { name: 'webDavConfig', type: 'InputWebDavFspConfig' },
      { name: 'sharePoint365Config', type: 'InputOneDriveFspConfig' },
    ],
  },
  fieldDefinitions: fields,
};
